import Result from "crocks/Result";

export const minLen = (min, msg = `Value cannot be shorter than ${min}`) => value =>
  value < min ? Result.Err(msg) : Result.Ok(value);

export const maxLen = (max, msg = `Value cannot be longer than ${max}`) => value =>
  value > max ? Result.Err(msg) : Result.Ok(value);
